import React, { useEffect, useState } from 'react';

const UserAdminManagement = () => {
  const [adminUsers, setAdminUsers] = useState([]);

  useEffect(() => {
    fetchAdminUsers();
  }, []);

  const fetchAdminUsers = async () => {
    try {
      const res = await fetch(`${process.env.REACT_APP_API_URL}/api/admin-users`);
      if (!res.ok) throw new Error('Failed to fetch admin users');
      const data = await res.json();
      setAdminUsers(data || []);
    } catch (err) {
      console.error('Error fetching admin users:', err);
    }
  };

  const handleDelete = async (id) => {
    try {
      const res = await fetch(`${process.env.REACT_APP_API_URL}/api/admin-users/${id}`, { method: 'DELETE' });
      if (!res.ok) throw new Error('Failed to delete admin user');
      setAdminUsers(adminUsers.filter(admin => admin.id !== id));
    } catch (err) {
      console.error('Error deleting admin user:', err);
      alert('Error deleting admin user: ' + err.message);
    }
  };

  return (
    <div style={{ marginTop: '40px' }}>
      <h2>Admin Users</h2>
      <button onClick={() => alert('TODO: Create Admin User')} style={{ marginBottom: '10px' }}>
        Create Admin User
      </button>
      <table style={{ width: '100%', borderCollapse: 'collapse' }}>
        <thead>
          <tr>
            <th style={{ borderBottom: '1px solid #ccc', textAlign: 'left', padding: '8px' }}>Email</th>
            <th style={{ borderBottom: '1px solid #ccc', textAlign: 'left', padding: '8px' }}>Created</th>
            <th style={{ borderBottom: '1px solid #ccc', textAlign: 'left', padding: '8px' }}>Actions</th>
          </tr>
        </thead>
        <tbody>
          {adminUsers.map((admin, idx) => (
            <tr key={admin.id || `admin-${idx}`}>
              <td style={{ borderBottom: '1px solid #eee', padding: '8px' }}>{admin.email}</td>
              <td style={{ borderBottom: '1px solid #eee', padding: '8px' }}>
                {admin.createdAt ? new Date(admin.createdAt).toLocaleDateString('en-GB') : 'N/A'}
              </td>
              <td style={{ borderBottom: '1px solid #eee', padding: '8px' }}>
                <button onClick={() => handleDelete(admin.id)} style={{ backgroundColor: '#ef4444', color: '#fff', border: 'none', padding: '6px 10px', borderRadius: '4px', cursor: 'pointer' }}>
                  Delete
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default UserAdminManagement;
